import { BookingHeader } from '../../booking/BookingParts';
import { useFormHorarioClienteContext } from './Context';

const STEP_TITLES: Record<string, string> = {
    estab: 'Onde você quer agendar?',
    atendente: 'Escolha o profissional',
    servico: 'Escolha os serviços',
    horario: 'Escolha o dia e o horário',
    confirm: 'Confira seu agendamento',
};

export const AgendaFormHeader = ({ step }: { step: string }) => {
    const { atendente, servico, servicosExtras, attendantCount, hasEstabChoice, canStepBack, stepBack, loading } =
        useFormHorarioClienteContext();

    // So contam as etapas em que o cliente de fato escolhe algo.
    const steps = [
        hasEstabChoice && 'estab',
        attendantCount !== 1 && 'atendente',
        'servico',
        'horario',
        'confirm',
    ].filter(Boolean) as string[];

    const recap = [
        (attendantCount || 0) > 1 && atendente?.displayName ? `Com ${atendente.displayName}` : '',
        step !== 'servico' && servico?.name
            ? [servico.name, ...servicosExtras.map((extra: any) => extra?.name)].filter(Boolean).join(' + ')
            : '',
    ].filter(Boolean);

    return (
        <BookingHeader
            steps={steps}
            step={step}
            title={STEP_TITLES[step]}
            recap={step !== 'confirm' ? recap.join(' · ') : ''}
            canStepBack={canStepBack}
            onBack={stepBack}
            loading={loading}
        />
    );
};
